import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment'

// Interfaces
import { ICompanyDepartment } from '@app/interfaces/company-department.interface';

@Injectable({ providedIn: 'root' })
export class CompanyDepartmentService {

    constructor(private http: HttpClient) { }

    getAll(): Observable<ICompanyDepartment[]> {
        return this.http.get<ICompanyDepartment[]>(environment.apiUrl + "/company-departments");
    }
}
